import $ from 'jquery'

import emitter from 'garden/src/js/utils/emitter'

import BaseComponent from 'scripts/components/base-component'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'

class AddressInfo extends BaseComponent {
  static componentName = 'address-info'

  static DOMEvents = {
    focusout: 'onFocusOut'
  }

  get (zipCode) {
    showSpinner()

    $.get('/endereco/' + zipCode)
      .done(this.done)
      .fail(this.fail)
  }

  onFocusOut (event) {
    this.get(event.target.value)
  }

  done (data) {
    hideSpinner()

    const inputs = document.querySelectorAll('[data-fill]')

    inputs.forEach(function (input) {
      input.value = data[input.dataset.fill] !== ' ' ? data[input.dataset.fill] : null
      $(input).trigger('change')
      $(input).trigger('focusout')
    })
  }

  fail () {
    hideSpinner()

    emitter.emit('stickyFeedback:error', {
      title: 'Ops! Não consegui encontrar o seu CEP :/'
    })
  }
}

/* istanbul ignore next */
export default ($el) => new AddressInfo($el)

export { AddressInfo as Component }
